
<template>
  
    <div class="section">
      <img class="unshackled" src="../assets/unshackled.svg">
      <h1>Display 1 of 75000 CONVICTS <br> on the CONVICT MEMORIAL</h1>
      <div class="cta-stack">
        <CustomButton @click="startSearch" :buttonTitle="'CHOOSE A RANDOM CONVICT'" :buttonIcon="'dice'" :buttonColour="'red'" minWidth='360px' ></CustomButton>
        <h2 class="or">OR</h2>
        <CustomButton @click="startFind" :buttonTitle="'SEARCH FOR YOUR CONVICT'" :buttonIcon="'search'" :buttonColour="'red'" minWidth='360px'></CustomButton>
        <h2 class="or">OR</h2>
        <CustomButton @click="startBrowse" :buttonTitle="'BROWSE THE LIBRARY OF LAGS'" :buttonIcon="'maleBTN'" :buttonColour="'red'" minWidth='360px'></CustomButton>
      
      </div>
    </div>
  
</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
export default {
  name: "HomeView",
  components: {
    CustomButton,
  },
  methods: {
    
    startSearch() {
      this.$store.commit('setMode','search')
      this.$router.push('/search');
    },
    startFind() {
      this.$store.commit('setMode','find')
      this.$router.push('/find');
    },
    startBrowse() {
      this.$store.commit('setMode','browse')
      this.$router.push('/lags');
    },
  },
};
</script>
<style>
.section {
  margin-top: 3em;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  gap: 1em;
}
</style>
<style scoped>

.section {
  /* Center vertically on Home only */
  margin-top: 0;
  min-height: 80dvh;
  padding: 6vh 1.5rem;
  padding-bottom: calc(8vh + env(safe-area-inset-bottom, 0));
  justify-content: space-between;
  gap: 1.5em;
  width: min(100%, 960px);
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.cta-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25em;
}

:deep(.cta-stack) .custom-button {
  /* tighten vertical margin for buttons just on Home */
  margin-top: 0.25em;
  margin-bottom: 0.25em;
}


.unshackled {
  width: clamp(18rem, 90vw, 33rem);
  max-width: 100%;
  height: auto;
}
.convict-memorial {
  font-size: clamp(4.5em, 17.5vw, 6em);
  margin-top: 0.1em;
  line-height: 0.85em;
}
.paragraph {
  font-size: clamp(2em, 8vw, 2.75em);
  line-height: 0.95em;
}
h1 {
  margin: 0;
  white-space: normal;
  font-size: clamp(2.2rem, 5vw, 3.2rem);
  line-height: 1.05;
  letter-spacing: 0.045em;
}
h2.or {
  margin: .3em 0;
}

@media (max-width: 500px) {
  .section {
    min-height: 100dvh;
    padding: 10vh 1.25rem;
    padding-bottom: calc(12vh + env(safe-area-inset-bottom, 0));
    gap: 2.25em;
  }

  .unshackled {
    width: min(80vw, 18rem);
  }

  h1 {
    font-size: clamp(1.9rem, 7vw, 2.4rem);
    line-height: 1.15;
  }

  .cta-stack {
    width: 100%;
    gap: 0.75em;
  }

  :deep(.cta-stack) .custom-button {
    width: min(22rem, 100%);
  }

  h2.or {
    margin: 0.75em 0 0.25em;
    font-size: clamp(1.1rem, 4.5vw, 1.35rem);
  }
}
</style>
